<script setup lang="ts">
import type { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/vue-3';
import { computed } from 'vue';

// ── Props ─────────────────────────────────────────────────────────────

const props = defineProps<NodeViewProps>();

// ── Collect all footnotes from the document in order ──────────────────

interface FootnoteEntry {
    id: string;
    number: number;
    content: string;
}

const footnotes = computed<FootnoteEntry[]>(() => {
    if (!props.editor) {
        return [];
    }

    const items: FootnoteEntry[] = [];
    let n = 0;
    props.editor.state.doc.descendants((node) => {
        if (node.type.name === 'footnoteRef') {
            n++;
            items.push({
                id: node.attrs.footnoteId as string,
                number: n,
                content: (node.attrs.content as string) || '(note vide)',
            });
        }

        return true;
    });

    return items;
});
</script>

<template>
    <NodeViewWrapper
        as="div"
        class="footnote-list my-8 border-t border-border/50 pt-4"
        contenteditable="false"
    >
        <p
            class="mb-2 text-xs font-semibold tracking-wide text-muted-foreground uppercase"
        >
            Notes de bas de page
        </p>
        <ol class="space-y-1">
            <li
                v-for="fn in footnotes"
                :key="fn.id"
                class="flex gap-2 text-sm text-foreground"
            >
                <span class="shrink-0 font-semibold text-primary"
                    >[{{ fn.number }}]</span
                >
                <span class="text-muted-foreground">{{ fn.content }}</span>
            </li>
        </ol>
        <p
            v-if="footnotes.length === 0"
            class="text-sm text-muted-foreground italic"
        >
            Aucune note de bas de page.
        </p>
    </NodeViewWrapper>
</template>
